const ai_analysis_routes = [
  {
    path: "/ai_analysis",
    name: "AiAnalysis",
    meta: {
      auth: true,
      translated: "Análises com IA",
      permission: { act: "read", on: "DoneForm" },
    },
    // component: v_ai_analysis_page,
    component: () => import("./pages/AiAnalysisPage.vue"),
    // beforeEnter: checkToken,
  },
];

export default ai_analysis_routes;
